import React from "react";
import { Link } from "react-router-dom";
import { COLORS, FONT, RADIUS, SHADOW } from "../theme";

const ATUALIZADO_EM = "09 de setembro de 2026";

function Secao({ titulo, children }) {
  return (
    <section style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: COLORS.text, margin: "0 0 10px" }}>{titulo}</h2>
      <div style={{ fontSize: 15, lineHeight: 1.7, color: COLORS.textMid }}>{children}</div>
    </section>
  );
}

export default function ExclusaoDados() {
  return (
    <div style={{ minHeight: "100dvh", background: COLORS.bg, fontFamily: FONT }}>
      <header
        style={{
          background: `linear-gradient(120deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 100%)`,
          padding: "22px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={`${process.env.PUBLIC_URL}/icon-pontozipar.png`} alt="" style={{ width: 32, height: 32, borderRadius: 8 }} />
          <span style={{ color: COLORS.white, fontWeight: 700, fontSize: 18 }}>PontoZipar</span>
        </div>
        <Link to="/login" style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, textDecoration: "none" }}>
          ← Voltar ao login
        </Link>
      </header>

      <main style={{ maxWidth: 760, margin: "0 auto", padding: "40px 24px 80px" }}>
        <div
          style={{
            background: COLORS.surface,
            borderRadius: RADIUS.xl,
            boxShadow: SHADOW.card,
            border: `1px solid ${COLORS.border}`,
            padding: "36px 40px",
          }}
        >
          <h1 style={{ fontSize: 26, fontWeight: 800, color: COLORS.text, margin: "0 0 6px" }}>
            Exclusão de Conta e de Dados
          </h1>
          <p style={{ fontSize: 13, color: COLORS.textLight, margin: "0 0 32px" }}>
            Última atualização: {ATUALIZADO_EM}
          </p>

          <Secao titulo="Sobre este aplicativo">
            O <strong>PontoZipar</strong> é o sistema de ponto eletrônico desenvolvido e operado pela{" "}
            <strong>Zipar Soluções Empresariais LTDA</strong>, CNPJ 68.173.181/0001-91. Esta página explica
            como pedir a exclusão da sua conta e dos seus dados.
          </Secao>

          <Secao titulo="Como pedir a exclusão">
            No PontoZipar, os logins são criados e gerenciados pela empresa que emprega você — por isso, a
            exclusão não é feita diretamente pelo próprio app (não existe hoje um botão de "excluir minha
            conta" dentro do sistema). Para solicitar a exclusão da sua conta e dos seus dados, escolha uma
            das opções abaixo:
            <ul style={{ margin: "10px 0 0", paddingLeft: 20 }}>
              <li>Peça ao seu gestor ou ao RH da empresa que te emprega, que pode remover seu cadastro; ou</li>
              <li>
                Mande um e-mail pra{" "}
                <a href="mailto:contato@pontozipar.com.br" style={{ color: COLORS.primary }}>
                  contato@pontozipar.com.br
                </a>{" "}
                informando seu nome completo e a empresa (tenant) em que seu cadastro está vinculado.
              </li>
            </ul>
          </Secao>

          <Secao titulo="O que é excluído e o que é mantido">
            Ao processar um pedido de exclusão:
            <ul style={{ margin: "10px 0 0", paddingLeft: 20 }}>
              <li>
                <strong>São excluídos:</strong> nome, CPF, telefone, e-mail, foto de perfil e o login de
                acesso ao sistema.
              </li>
              <li>
                <strong>São mantidos por exigência legal:</strong> os registros de ponto (horários de
                entrada/saída/intervalo, e as selfies e localizações capturadas em cada batida) — a
                legislação trabalhista brasileira (CLT) exige a guarda desses registros por até 5 anos
                (prazo de prescrição de ações trabalhistas), mesmo após o fim do vínculo empregatício ou a
                exclusão do cadastro pessoal. Esses registros deixam de estar associados a um cadastro
                ativo, mas continuam guardados pelo prazo legal como prova de jornada trabalhada.
              </li>
            </ul>
          </Secao>

          <Secao titulo="Prazo de resposta">
            Pedidos de exclusão são atendidos em até 15 dias úteis.
          </Secao>

          <Secao titulo="Mais detalhes">
            Pra entender tudo o que o PontoZipar coleta e por quê, veja nossa{" "}
            <Link to="/privacidade" style={{ color: COLORS.primary }}>
              Política de Privacidade
            </Link>
            .
          </Secao>
        </div>

        <p style={{ textAlign: "center", fontSize: 12, color: COLORS.textLight, marginTop: 20 }}>
          Zipar Soluções Empresariais LTDA — CNPJ 68.173.181/0001-91
        </p>
      </main>
    </div>
  );
}
